module.exports = __webpack_public_path__ + "img/diners.93366e7a.svg";